/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharekindplan2Inputs */

const en_sharekindplan2 = /** @type {(inputs: Sharekindplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const de_sharekindplan2 = /** @type {(inputs: Sharekindplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Sharekindplan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharekindplan2 = /** @type {((inputs?: Sharekindplan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharekindplan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharekindplan2(inputs)
	return de_sharekindplan2(inputs)
});
export { sharekindplan2 as "shareKindPlan" }